import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

const Card = ({ children, className }) => {
  const classNames = [styles.container];
  if (className) {
    classNames.push(className);
  }

  return <div className={classNames.join(' ')}>{children}</div>;
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

Card.defaultProps = {
  className: null
};

export default Card;
